import { FC } from 'react';
import { CodeBlock as CodeBlockLib, monokai } from 'react-code-blocks';
import { IEntityContentField } from '../../../lib/interfaces/Common';
import './CodeBlock.scss';

type CodeBlockType = {
	field: IEntityContentField;
};

const CodeBlock: FC<CodeBlockType> = ({ field }) => {
	const language: string = field.options?.language || 'javascript';
	const code: string = field.content;
	const wrapLines = true;
	const codeBlock = true;
	return (
		<div className="CodeBlock">
			<CodeBlockLib
				language={language}
				text={code}
				showLineNumbers={false}
				theme={monokai}
				{...{ wrapLines, codeBlock }}
			/>
		</div>
	);
};

export default CodeBlock;
